import type { ReactNode } from "react";

const TITLE: Record<"lg" | "md", string> = {
  lg: "text-body-lg text-midnight font-bold",
  md: "text-body text-midnight font-bold",
};

interface HomeCardProps {
  title: string;
  titleSize: "lg" | "md";
  /** Rendered beside the title, outside the `<h2>` so it stays out of the heading's accessible name. */
  titleBadge?: ReactNode;
  /** Rendered at the right end of the title row, such as a "See all" link. */
  action?: ReactNode;
  children: ReactNode;
}

/** A Home card section with an `<h2>` title. */
export function HomeCard({
  title,
  titleSize,
  titleBadge,
  action,
  children,
}: HomeCardProps): ReactNode {
  return (
    <section className="border-haze flex flex-col gap-4 rounded-2xl border bg-white p-6">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <h2 className={TITLE[titleSize]}>{title}</h2>
          {titleBadge}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
